export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-4 md:mb-8">
    <div>
      <h1 data-testid="page-title" className="font-display text-3xl font-bold tracking-tight sm:text-4xl">{title}</h1>
      {subtitle && <p className="mt-2 text-sm text-zinc-500 md:text-base">{subtitle}</p>}
    </div>
    {children}
  </div>
);

export const DataTable = ({ testid, head, rows, empty }) => (
  <div data-testid={testid} className="overflow-x-auto rounded-xl border border-white/5 bg-[#0f0f12]">
    <table className="w-full min-w-[640px] text-sm">
      <thead>
        <tr className="border-b border-white/5 text-left text-xs uppercase tracking-wider text-zinc-500">
          {head.map((h) => <th key={h} className="px-5 py-3 font-medium">{h}</th>)}
        </tr>
      </thead>
      <tbody>
        {rows}
        {rows.length === 0 && (
          <tr><td colSpan={head.length} className="px-5 py-12 text-center text-zinc-500">{empty}</td></tr>
        )}
      </tbody>
    </table>
  </div>
);
